export const ADD_QUOTE_TEST_IDS = {
  PLANS: 'add-quote-plans-test-id',
  SECTION: 'add-quote-product-line-section-test-id',
  SECTION_TOGGLE: 'add-quote-product-line-section-toggle-test-id',
  EMPTY_STATE: 'add-quote-product-line-empty-state-test-id',
  ADD_PLAN_BUTTON: 'add-quote-add-plan-button-test-id',
  REMOVE_PLAN_BUTTON: 'add-quote-remove-plan-button-test-id',
  VALIDATION_ALERT: 'add-quote-validation-alert-test-id',
};
